import { render, staticRenderFns } from "./DesignRirekishoJobDetailHistoryCard.vue?vue&type=template&id=03fb9a5e"
import script from "./DesignRirekishoJobDetailHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekishoJobDetailHistoryCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports